import { bannerState } from '../../stores';

import { sendRaisedHand } from '.';

export function changeHandStatus(isRaised: boolean, problemId?: string) {
  bannerState().setIsHandRaised(isRaised, problemId);
  sendRaisedHand(isRaised, problemId);
}
